import declare from "dojo/_base/declare";

import AggregateFrom from "csi/table/AggregateFrom";
import xml from "csi/xml";
import BusinessObject from "./BusinessObject";

const APPLICABLE_TYPES = "ApplicableTypes";
const AggregateFromCommentCategory = declare(AggregateFrom, {
	/**
	 * @override
	 * Add the applicable types
	 */
	_processAppendNode(node) {
		const bo = this.getParent();
		const typeName = BusinessObject.getRootType(bo);
		this.m_writer.changeNode(node.$URL).changeAttribute(APPLICABLE_TYPES, xml.ATTR_STRINGSET, [typeName], true);

		return this.inherited(arguments);
	},

	/**
	 * @override
	 * Remove the applicable types
	 */
	_processRemoveNode(node) {
		const bo = this.getParent();
		const typeName = BusinessObject.getRootType(bo);
		this.m_writer.changeNode(node.$URL).changeAttribute(APPLICABLE_TYPES, xml.ATTR_STRINGSET, [typeName], false, true);

		return this.inherited(arguments);
	},
});

export = AggregateFromCommentCategory;